module.exports = __webpack_public_path__ + "img/resource-tech-image-59.626e8b18.jpg";